module.exports = __webpack_public_path__ + "static/media/Electrophoresis_Box.c4817ad8.svg";